// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDvPZV_Rmxkg1sz_STdzHZxUt-Vjcz1CIU",
  authDomain: "react-auth-8c26a.firebaseapp.com",
  projectId: "react-auth-8c26a",
  storageBucket: "react-auth-8c26a.appspot.com",
  messagingSenderId: "868179217229",
  appId: "1:868179217229:web:2df090fe6bcff4ce8e4504"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

